import { Box, Button, IconButton, Menu, MenuItem, Switch, Tab, Tabs } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import SearchBar from '../../components/SearchBar';
import TableComponent from '../../components/TableComponent';
import MainContainer from '../../layout/MainContainer';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const ManageTechFeatures = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [valueTabs, setValueTabs] = React.useState(0);
  const [hidden, setHidden] = useState<string[]>([]);
  const [openModal, setOpenModal] = useState(false);
  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const label = { inputProps: { 'aria-label': 'Switch demo' } };

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const open1 = Boolean(anchorEl1);

  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };
  const rows = [
    {
      id: 1,
      image: '/static/images/shipping_02.jpg',
      name: 'Honda',
    },
    {
      id: 2,
      image: '/static/images/shipping_02.jpg',
      name: 'Honda',
    },
    {
      id: 3,
      image: '/static/images/shipping_02.jpg',
      name: 'Honda',
    },
    {
      id: 4,
      image: '/static/images/shipping_02.jpg',
      name: 'Honda',
    },
  ];

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 0.8,
      minWidth: 200,
      field: 'image',
      headerName: 'Technical Feature Image',
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <figure>
              <img src={row?.image} alt="" />
            </figure>
          </div>
        );
      },
    },
    {
      flex: 0.8,
      minWidth: 200,
      field: 'name',
      headerName: 'Technical Feature Name',
      editable: false,
      sortable: false,
    },
    {
      flex: 0.1,
      minWidth: 150,
      field: 'status',
      filterable: false,
      sortable: false,
      headerName: 'Block/Unblock',
      renderCell: ({ row }) => {
        return (
          <Switch
            {...label}
            size="small"
            defaultChecked
            // onChange={() => updateStatus(row?._id)}
          />
        );
      },
    },

    {
      flex: 0.1,
      minWidth: 80,
      field: 'action',
      headerName: 'Action',
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                aria-controls={open1 ? 'basic-menu1' : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? 'true' : undefined}
                onClick={handleClick1}
              >
                <img src="/static/images/more_icon.svg" alt="" />
              </IconButton>
              <Menu
                className="setting_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  'aria-labelledby': 'basic-button1',
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.05)',
                    borderRadius: '8px',
                    mt: 1,
                  },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                <MenuItem onClick={() => navigate('edit/1')}>Edit</MenuItem>
                <MenuItem onClick={handleClose1}>Delete</MenuItem>
              </Menu>
            </Box>
          </div>
        );
      },
    },
  ];

  return (
    <MainContainer>
      <div className="main_title fdx">
        <div>
          <h1> Technical Features</h1>
          <p>
            <span onClick={() => navigate('/dashboard')}>Dashboard</span> - Vehicle Specifications -
            Technical Features
          </p>
        </div>
        <div className="right_s align_right">
          <Button className="btn btn_orange" onClick={() => navigate('add')}>
            Add Technical Feature
          </Button>
        </div>
      </div>

      <div className="cards">
        <Box className="custom_tabs" sx={{ width: '100%' }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setSearchTerm}
                  placeholder="Search "
                />
              </Box>
            </div>
          </div>

          <Tabs
            value={valueTabs}
            onChange={handleChangeTabs}
            aria-label="basic tabs example"
            className="custom_tabs_links"
          >
            <Tab label="Car (10)" {...a11yProps(0)} />
            <Tab label="Bike (10)" {...a11yProps(1)} />
            <Tab label="Truck (10)" {...a11yProps(2)} />
            <Tab label="Heavy Vehicles (10)" {...a11yProps(2)} />
          </Tabs>

          <CustomTabPanel value={valueTabs} index={0}>
            <div className="sorting_table">
              <TableComponent
                columns={columns?.filter((item: any) => !hidden.includes(item.field))}
                rows={rows}
              />
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={1}>
            <div className="sorting_table">
              <TableComponent
                columns={columns?.filter((item: any) => !hidden.includes(item.field))}
                rows={rows}
              />
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={2}>
            <div className="sorting_table">
              <TableComponent
                columns={columns?.filter((item: any) => !hidden.includes(item.field))}
                rows={rows}
              />
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={3}>
            <div className="sorting_table">
              <TableComponent
                columns={columns?.filter((item: any) => !hidden.includes(item.field))}
                rows={rows}
              />
            </div>
          </CustomTabPanel>
        </Box>
      </div>
    </MainContainer>
  );
};

export default ManageTechFeatures;
